import { createFileRoute } from '@tanstack/react-router';
import { ApproverChainPage } from '@/features/payroll/approver-chain-page';
import { guardRoute } from '@/lib/route-guards';

export const Route = createFileRoute('/_app/admin/payroll-approvers')({
  beforeLoad: ({ context }) => {
    guardRoute(context.auth, '/admin/payroll-approvers');
  },
  component: ApproverChainPage,
});
